import { Link } from "react-router-dom";

const OCCASIONS = [
  { label: "Dia a Dia", desc: "Para usar todos os dias", filter: "Dia a Dia" },
  { label: "Casamento", desc: "Para o sim e além", filter: "Casamento" },
  { label: "Noivado", desc: "O símbolo de um começo", filter: "Noivado" },
  { label: "Ocasião Especial", desc: "Datas que merecem brilho", filter: "Ocasião Especial" },
];

const RANGES = [
  { label: "Até R$ 5.000", params: { max_price: "5000" }, testid: "range-up-to-5000" },
  { label: "R$ 5.000 – R$ 10.000", params: { min_price: "5000", max_price: "10000" }, testid: "range-5000-10000" },
  { label: "Acima de R$ 10.000", params: { min_price: "10000" }, testid: "range-above-10000" },
];

function buildQuery(params) {
  const qs = new URLSearchParams(params).toString();
  return qs ? `?${qs}` : "";
}

export default function PresentesPage() {
  return (
    <div data-testid="presentes-page">
      <section className="bg-[#FAF9F7] py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="overline text-[#A8A8A8] mb-4">Guia de Presentes</p>
          <h1 className="font-display text-5xl md:text-6xl mb-5 leading-tight">O presente certo para cada momento</h1>
          <p className="font-italic-display text-xl text-[#6B6B6B]">para surpreender e emocionar.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20">
        <h2 className="font-display text-3xl md:text-4xl mb-10">Por Ocasião</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {OCCASIONS.map((o) => (
            <Link
              key={o.label}
              to={`/joias/todos?ocasiao=${encodeURIComponent(o.filter)}`}
              className="bg-[#FAF9F7] p-10 hover:bg-white hover:border-[#B8A88A] border border-transparent transition-all"
              data-testid={`occasion-${o.label}`}
            >
              <h3 className="font-display text-2xl mb-2">{o.label}</h3>
              <p className="text-sm text-[#6B6B6B]">{o.desc}</p>
            </Link>
          ))}
        </div>

        <h2 className="font-display text-3xl md:text-4xl mb-10 mt-24">Por Faixa de Investimento</h2>
        <div className="grid md:grid-cols-3 gap-5">
          {RANGES.map((r) => (
            <Link
              key={r.label}
              to={`/joias/todos${buildQuery(r.params)}`}
              className="bg-[#1A1A1A] text-white p-10 hover:bg-[#B8A88A] transition-colors"
              data-testid={r.testid}
            >
              <p className="overline text-[#B8A88A] mb-3">Investimento</p>
              <h3 className="font-display text-3xl">{r.label}</h3>
            </Link>
          ))}
        </div>

        <div className="mt-24 bg-[#FAF9F7] p-12 text-center">
          <p className="overline text-[#B8A88A] mb-3">Disponível agora</p>
          <h2 className="font-display text-3xl md:text-4xl mb-4">Gift Cards Prize Joias</h2>
          <p className="text-[#6B6B6B] mb-6">Para quando o coração já decidiu — mas a peça, ainda não.</p>
          <Link to="/gift-card" className="btn-accent" data-testid="presentes-giftcard-cta">
            Comprar gift card
          </Link>
          <p className="text-xs text-[#A8A8A8] mt-4">Entrega digital imediata</p>
        </div>
      </section>
    </div>
  );
}
